import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const dataSourceTypesEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-data-source-types" */ './DataSourceTypesPage.tsx'),
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
